import * as React from 'react';

function clock( props: React.SVGProps<SVGSVGElement> ) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.49 1a.76.76 0 00-.76.76v1.52a.76.76 0 00.76.76h1.14v2.012C8.408 6.998 2 14 2 22.47 2 31.584 9.416 39 18.53 39c9.113 0 16.53-7.416 16.53-16.53a16.424 16.424 0 00-2.554-8.81l1.61-1.303.718.886a.76.76 0 001.07.113l1.181-.957a.76.76 0 00.112-1.068L33.37 6.605a.76.76 0 00-1.069-.113l-1.182.957a.76.76 0 00-.112 1.069l.718.886-1.603 1.297a16.488 16.488 0 00-9.693-4.648V4.04h1.14a.76.76 0 00.76-.76V1.76a.76.76 0 00-.76-.76h-6.08zm3.04 7.6A13.85 13.85 0 0132.4 22.47a13.85 13.85 0 01-13.87 13.87A13.85 13.85 0 014.66 22.47 13.85 13.85 0 0118.53 8.6zm0 2.828V22.47l8.829 6.63a11.041 11.041 0 00-8.828-17.671z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default clock;
